// src/store/slices/globalErrorsSlice.js
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	cartError: null, // Update error key to cartError
}

const globalErrorsSlice = createSlice({
	name: 'globalErrors',
	initialState,
	reducers: {
		setCartError(state, action) {
			// Rename the action to setCartError
			state.cartError = action.payload
		},
		clearCartError(state) {
			// Rename the action to clearCartError
			state.cartError = null
		},
	},
})

export const { setCartError, clearCartError } = globalErrorsSlice.actions // Export the updated actions
export default globalErrorsSlice.reducer
